import React from 'react';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';

interface TemplateCardProps {
  code: string;
  description: string;
  knownParameters: string[];
  onEdit: () => void;
}

function formatCodeToSentence(code: string) {
  // Remove hyphens, split into words, capitalize first letter, join as sentence
  if (!code) return '';
  const words = code.split('-');
  const sentence = words.map((w, i) => (i === 0 ? w.charAt(0).toUpperCase() + w.slice(1) : w)).join(' ');
  return sentence;
}

const TemplateCard: React.FC<TemplateCardProps> = ({ code, description, onEdit }) => {
  return (
    <div className='template-card'>
      <h3>{formatCodeToSentence(code)}</h3>
      <p>{description}</p>
      <div className='template-card-actions'>
        <IconButton onClick={onEdit} size='small' aria-label='edit' color='primary' className='edit-btn-bordered'>
          <EditIcon /> Edit
        </IconButton>
      </div>
    </div>
  );
};

export default TemplateCard;
